import { NSAHomePage, NSARouterMakerResult } from "namirasoft-account-react";
import { BalanceLayout } from "../BalanceLayout";
import { BalanceRouterProps } from "../BalanceRouterProps";
import { AssetBalances } from "../components/AssetBalances";
import { BalanceOverview } from "../components/BalanceOverview";

interface HomePageProps extends NSARouterMakerResult, BalanceRouterProps { }

export default function HomePage(props: HomePageProps)
{
	return (
		<BalanceLayout
			{...props}
		>
			<NSAHomePage
				{...props}
				getChildren={{
					getChildrenBefore()
					{
						return <>
							<AssetBalances server={props.servers.balance} />
							<BalanceOverview server={props.servers.balance} />
						</>
					}
				}}
			/>
		</BalanceLayout>
	);
}